<template>
  <BoxComponent>
    <BoxComponent :pl="32" :pr="32">
      <InfluencerHeader
        :user-image="influencer.userImage"
        :username="loading ? '...' : influencer.username"
        :real-name="influencerName"
        :social-media="influencer.socialMediaAccounts"
        :my-page="myPage"
        :tags="influencer.userTags"
        :influencer-id="influencer.userId"
      />
    </BoxComponent>
    <InfluencerDetailTabs :influencer="influencer" />
  </BoxComponent>
</template>

<script lang="ts">
import { BoxComponent, buildMyPageLink } from '@metapic-apps/shared'
import { mapActions, mapGetters } from 'vuex'

import InfluencerDetailTabs from '@/components/influencer/InfluencerDetailTabs.vue'
import InfluencerHeader from '@/components/influencer/InfluencerHeader.vue'
import { config } from '@/lib/helpers'

export default {
  name: 'Influencer',
  components: {
    BoxComponent,
    InfluencerDetailTabs,
    InfluencerHeader,
  },
  middleware: 'auth',
  // eslint-disable-next-line vue/require-prop-types
  props: ['id'],
  computed: {
    ...mapGetters('influencer', ['loading', 'influencer']),
    myPage() {
      return buildMyPageLink(config.myPagePublicUrl, this.influencer.myPageSlug)
    },
    influencerName: function () {
      if (this.loading) {
        return '...'
      } else {
        return this.influencer.firstName ? `${this.influencer.firstName} ${this.influencer.surname}` : this.influencer.username
      }
    },
  },
  watch: {
    id(newId) {
      if (this.influencer.userId !== Number(newId)) {
        this.fetchInfluencer({ userId: newId })
      }
    },
  },
  created() {
    if (this.influencer.userId !== Number(this.id)) {
      this.fetchInfluencer({ userId: this.id })
    }
    this.$store.dispatch('trafficSources/fetchTrafficSources')
  },
  methods: {
    ...mapActions('influencer', ['fetchInfluencer']),
  },
}
</script>
